import { Form } from "formik";
import React, { Component } from "react";

import Button from "../../../../components/UI/Button";
import { CustomForm } from "../../../../component-library/CustomForm";
import FormikInput from "../../../../components/UI/FormikInput";

import { convertStatus, INITIAL, OUTCOME } from "./ClinicalAssessment";
import {
  INITIAL_CLINICAL_NOTES_VALIDATION_SCHEMA,
  OUTCOME_CLINICAL_NOTES_VALIDATION_SCHEMA,
} from "./schema/clinicalAssessmentValidation";
import {
  INITIAL_CLINICIAN_NOTES_SCHEMA,
  OUTCOME_CLINICIAN_NOTES_SCHEMA,
} from "./schema/clinicalAssessmentFormSchema";

import "./styles.scss";

class ClinitianNotes extends Component {
  constructor(props) {
    super(props);

    let formSchema, formValidation;

    switch (props.type) {
      case INITIAL: {
        formSchema = INITIAL_CLINICIAN_NOTES_SCHEMA;
        formValidation = INITIAL_CLINICAL_NOTES_VALIDATION_SCHEMA;
        break;
      }

      case OUTCOME: {
        formSchema = OUTCOME_CLINICIAN_NOTES_SCHEMA;
        formValidation = OUTCOME_CLINICAL_NOTES_VALIDATION_SCHEMA;
        break;
      }
    }

    this.state = {
      clinician_rating: props.vals,
      formSchema,
      formValidation,
    };
  }

  submitHandler = (formData, actions) => {
    let data = { ...this.props.data };

    data[convertStatus(this.props.statusArr[0])] = { ...formData };
    this.props.submitHandler(data, actions);
  };

  renderForm = (formikProps) => {
    return (
      <Form>
        <div className="mx-auto px-0">
          <fieldset disabled={this.props.done ? "disabled" : ""}>
            <div className="container">
              <div className="row clinicialTextbox-from-wpr">
                {this.state.formSchema.map((formEl) => {
                  return (
                    <div className="col-12" key={formEl.name}>
                      <FormikInput
                        clinicialTextbox="clinicialTextbox"
                        errors={formikProps.errors}
                        formEl={formEl}
                        grayBorder="borderGray"
                        touched={formikProps.touched}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </fieldset>
          <div className="d-flex justify-content-lg-end tw:justify-center">
            <div>
              <Button
                className="Btn Btn--otl-pri Btn-sm mr-3"
                onClick={() =>
                  this.props.history.push(
                    `/app/patient/${this.props.match.params.patientId}/profile`,
                  )
                }
                type="button"
              >
                Back
              </Button>
              <Button className="Btn Btn--pri Btn-sm" type="submit">
                Continue
              </Button>
            </div>
          </div>
        </div>
      </Form>
    );
  };

  render() {
    return (
      <div>
        <CustomForm
          initialValues={this.state.clinician_rating}
          onSubmit={this.submitHandler}
          render={this.renderForm}
          validationSchema={this.state.validationSchema}
        />
      </div>
    );
  }
}

export default ClinitianNotes;
